module.exports = __webpack_public_path__ + "img/clickpoint.2d7748e5.png";